/**
 * @file locales/index.ts
 * @description 国际化配置文件，配置 Vue I18n 实例和语言包
 */

import { createI18n } from 'vue-i18n'
import enSelf from './en_US.js' // 英文语言包
import cnSelf from './zh_CN.js' // 中文语言包

/**
 * 创建 i18n 实例
 * @description Vue I18n 国际化插件实例配置
 * @property locale - 默认语言为英文
 * @property legacy - 使用 Composition API 模式
 * @property globalInjection - 全局注入 $t 等函数
 * @property messages - 语言包配置
 */
export const i18n = createI18n({
  locale: 'en_US', // 默认语言
  legacy: false, // 禁用 legacy 模式，使用 Composition API
  globalInjection: true, // 全局注入，可在模板中直接使用 $t
  messages: {
    en_US: {
      ...enSelf, // 英文翻译
    },
    zh_CN: {
      ...cnSelf, // 中文翻译
    },
  },
})

/**
 * 支持的语言列表
 * @description 用于语言切换下拉菜单显示
 */
export const langs = [
  { key: 'zh_CN', title: '中文' }, // 中文
  { key: 'en_US', title: 'English' } // 英文
]
